module.exports = __webpack_public_path__ + "img/logo.9b7d9dd7.png";